// extracted by mini-css-extract-plugin
export var pillTrigger = "_66-0";